import { z } from 'zod';

export const addNullishByCondition = <Schema extends z.ZodSchema>({
    schema,
    condition,
}: {
    schema: Schema;
    condition?: boolean;
}): Schema | z.ZodOptional<z.ZodNullable<Schema>> => {
    if (condition) return schema.nullish();

    return schema;
};
